import axiosInstace from '../utils/axios';

const API_URL = `/api/header-settings`;

// Fetch all settings
export const fetchSettings = async () => {
  try {
    const response = await axiosInstace.get(API_URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create or update header settings
export const createOrUpdateHeaderSettings = async (data, logoFile) => {
  try {
    const formData = new FormData();

    // Append form fields
    formData.append('clubName', data.clubName);
    formData.append('clubSubtitle', data.clubSubtitle);
    formData.append('phoneNumber', data.phoneNumber);
    formData.append('email', data.email);
    formData.append('showPropertyQuestions', data.showPropertyQuestions);

    // Append navItems as a JSON string
    formData.append('navItems', JSON.stringify(data.navItems));

    // Append logo file if provided
    if (logoFile) {
      formData.append('logo', logoFile);
    }

    const response = await axiosInstace.post(API_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const toggleDropdown = async(id) => {
  try {
    await axiosInstace.patch(`/api/header-settings/dropdown-item/${id}/toggle-status`);
  } catch (error) {
    throw error;
  }
}

export const toggleNavItem = async(id) => {
  try {
    await axiosInstace.patch(`/api/header-settings/nav-item/${id}/toggle-status`);
  } catch (error) {
    throw error;
  }
}